<template>
    <v-card v-if='unit.apartment'
            outlined
            class='item d-flex flex-column mb-3'
            v-ripple
            :to="to"
    >
        <div class='item-image'>
            <img
                    class='card-image'
                    v-if='unit.cover'
                    :alt='unit.name'
                    :src='public_url+"/"+ unit.cover'
            />
            <img
                    class='card-image'
                    v-else
                    src='/assets/img-none.svg'
                    :alt='unit.name'/>
            <div class='notification'>
                <v-icon
                        v-if='translateStatus[unit.status].showAlert'
                        class='has-alert'
                        color='warning'
                >
                    mdi-bell-alert-outline
                </v-icon>
            </div>
            <div class='item-type blue' v-if="checkUserIsOwner">
                <span class='white--text'>{{checkUserIsOwner(unit.owners) ? 'مالک هستید' : 'مستاجر هستید'}}</span>
            </div>
        </div>
        <v-card-text class='py-1'>
            <div class="mb-2">
                <div style='font-size:12px;'>
                    <span> مجموعه </span>
                    <span> {{ unit.apartment.title }} </span>
                </div>
                <h4 class='black--text font-weight-bold'>

                    <span>{{ unit.apartment.type === 'TOWN' ? 'قطعه ' : 'واحد ' }}</span>
                    <span>{{ unit.name + unit.number }} </span>
                </h4>
            </div>
            <small class="d-flex mb-2">
                <v-icon class='ml-1'>mdi-pin</v-icon>
                <span class='ml-1' style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
                    {{ unit.apartment.province ? unit.apartment.province.title + ' - ' : ''}}{{ unit.apartment.city ? unit.apartment.city.title + ' - ' : ''
                    }}{{ unit.apartment.address }}
                </span>
            </small>
            <div class='mt-2 mr-1'>
                <v-badge
                        :color='translateStatus[unit.status].bgColor'
                >
                    <template #badge>
										<span :style='{color: translateStatus[unit.status].color}'>
											{{ translateStatus[unit.status].label }}
										</span>
                    </template>
                </v-badge>
            </div>
        </v-card-text>
        <slot></slot>
    </v-card>
</template>

<script>
    export default {
        name: 'AccountInfo',
        props: {
            checkUserIsOwner: Function,
            unit: Object,
            to: Object,

        },
        model: {
            prop: 'unit',
            event: 'change'
        },
        watch: {},
        data() {
            return {
                translateStatus: {
                    CREATED: {
                        value: 'CREATED',
                        label: 'ایجاد شده',
                        bgColor: '#fdf2d8',
                        color: 'black',
                        showAlert: true
                    },
                    REGISTERED: {
                        value: 'REGISTERED',
                        label: 'در انتظار تکمیل اطلاعات',
                        bgColor: 'yellow',
                        color: 'black',
                        showAlert: true
                    },
                    COMPLETED: {
                        value: 'COMPLETED',
                        label: 'تکمیل اطلاعات شده',
                        bgColor: 'grey',
                        color: '#FFFFFF',
                        showAlert: false
                    },
                    APPROVED: {
                        value: 'APPROVED',
                        label: 'تایید شده',
                        bgColor: 'blue',
                        color: '#FFFFFF',
                        showAlert: false
                    },
                    NOT_APPROVED: {
                        value: 'NOT_APPROVED',
                        label: 'تایید نشده',
                        bgColor: 'yellow',
                        color: 'black'
                    }
                },
            }
        },
        methods: {},
        computed: {},
        async created() {
        }
    };
</script>

<style scoped lang='scss'>
    .item {
        /*width: 240px;*/
        /*min-height: 330px;*/
        max-height: 330px;
        border-radius: 12px;
        padding: 4px;
        overflow: hidden;
        @media screen and (min-width: 600px) {
            /*min-height: 370px;*/
            max-height: 370px;
        }
    }

    .notification {
        position: absolute;
        left: 10px;
        top: 10px;

        .v-icon {
            font-size: 16px;
            border-radius: 50%;

            &.has-alert {
                //color: rgba(239, 83, 80, 1);
                animation: pulse 2s infinite;
            }
        }
    }

    .item-image {
        position: relative;
        border-radius: 12px !important;
        overflow: hidden;

        .card-image {
            filter: brightness(85%);
            border: 1px solid #efefef;
            border-radius: 12px !important;
            overflow: hidden;
            padding: 0;
            width: 100%!important;
            min-width: 100%;
            max-height: 150px;
            min-height: 150px;
            object-fit: cover;
            @media screen and (min-width: 600px) {
                max-height: 198px;
                min-height: 198px;
            }
        }

        .item-type {
            position: absolute;
            right: 10px;
            top: 10px;
            padding: 2px 6px 2px 4px;
            display: flex;
            font-size: 12px;
            align-items: center;
            border-radius: 12px;
            color: #000000;
            background-color: #fff;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
            /*border:1px solid #9b9b9b;*/
            opacity: 0.4;

            .v-icon {
                font-size: 12px;
                color: #000000;
            }
        }
    }

    label {
        display: block;
        margin-bottom: 4px;
    }

    small {
        display: block;

        .v-icon {
            font-size: 16px;
        }
    }
</style>